app.service("geolocation", function (modal, loading) {
	var options = {
		enableHighAccuracy: true,
		maximumAge: 60000,
		timeout: 20000
	};
	var geolocationSuccess, errorCallback;

	function findPosition(callback, error) {
		geolocationSuccess = function (position) {
			callback(position);
			loading.stop();
		};
		errorCallback = function (er) {
			if (typeof error == 'function') {
				error(er);
			}
		};
		if (isGeolocation()) {
			loading.start();
			getCurrentPosition();
		}
	}
	function isGeolocation() {
		if (!navigator.geolocation) {
			modal.alert('Przepraszamy, Twoja przeglądarka nie wspiera Geo Services');
			return false;
		} else {
			return true;
		}
	}
	function getCurrentPosition() {
		navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, options);
	}
	function geolocationError(error) {
		let text = '';
		if (options.enableHighAccuracy) {
			options.enableHighAccuracy = false;
			getCurrentPosition();
		} else {
			loading.stop();
			switch (error.code) {
				case error.TIMEOUT:
					text = 'Błąd - czas na określenie lokalizacji został przekroczony.';
					break;
				case error.POSITION_UNAVAILABLE:
					text = 'Błąd - określenie pozycji jest niemożliwe.';
					break;
				case error.PERMISSION_DENIED:
					text = 'Błąd - użytkownik nie pozwolił na lokalizację.';
					break;
				case error.UNKNOWN_ERROR:
					text = 'Nieznany błąd lokalizacji';
					break;
			}
			modal.alert(text);
			errorCallback();
		}
	}

	return {
		findPosition
	};
});